import { defaultStore, stores } from '../../translations'

/**
 * Подключаем ассеты adidas в игре doodle только на RU store
 * */
export const isJumperAdidasAssets = (store = defaultStore) => {
  const startDate = new Date('2026-09-28T12:00:00')
  const endDate = new Date('2026-10-31T23:59:59')
  const now = new Date()
  const iAdidasGameActive = now >= startDate && now <= endDate

  return iAdidasGameActive && store === stores.ru
}
